import httpRequest from '@/api/request'
import { GovernanceCommunityData, GovernanceData, RegionAccountList } from './interface'
/**
 * 分页查询系统地址列表
 * @limit pageSize
 * @offset pageNum 从便宜量0开始
 * @height 区块高度
 * @returns
 */
export const getRestAccountSystemAddress = ({
  limit = 10,
  offset = 0,
}: {
  limit: number
  offset: number
}): Promise<GovernanceData> => {
  return httpRequest.get('/api/rest/account/system_address', { params: { limit, offset } })
}

/**
 * 查询区域模块地址列表 account-list
 * @param params
 * @returns
 */
export const getRegionAccountList = (params = {}): Promise<RegionAccountList> => {
  return httpRequest.get('/api/rest/region/account-list', { params })
}

/**
 * 分页查询全网50个治理地址列表
 * @limit pageSize
 * @offset pageNum 从便宜量0开始
 * @returns
 */
export const getRestAccountGovernanceAddress = ({
  limit = 10,
  offset = 0,
}: {
  limit: number
  offset: number
}): Promise<GovernanceCommunityData> => {
  return httpRequest.get('/api/rest/account/governance_address', { params: { limit, offset } })
}
